// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1vqwo","ranges":"BmiRanges_ranges__lZ1fb"};